<template>
  <v-container fill-height fluid grid-list-xl class="white">
    <v-layout justify-center column>
      <v-flex>
        <v-container>
          <v-layout row wrap>
            <v-flex>
                <v-select
                    v-model="selectCommunities"
                    :items="itemsCommunities"
                    class = "body-1"
                    label = "Comunidad"
                ></v-select>
            </v-flex>
            <v-flex>
                <v-select
                    v-model="selectSample"
                    :items="itemsSample"
                    class = "body-1"
                    label = "Muestra"
                ></v-select>
            </v-flex>
            <v-flex>
              <v-menu
                ref="menufechaini"
                :close-on-content-click = "false"
                v-model = "menufechaini"
                :nudge-right = "40"
                :return-value.sync = "date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                    ref = "fechaini"
                    class = "body-1"
                    slot="activator"
                    prepend-icon="mdi-calendar"
                    label = "Fecha inicial"
                    v-model = "selectInitialDate"
                    required
                    readonly>
                </v-text-field>
                <v-date-picker header-color = "green darken-3" dark v-model = "selectInitialDate" @input="$refs.menufechaini.save(selectInitialDate)"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu
                ref="menufechafin"
                :close-on-content-click = "false"
                v-model = "menufechafin"
                class = "body-1"
                :nudge-right = "40"
                :return-value.sync = "date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                    ref = "fechafin"
                    class = "body-1"
                    slot="activator"
                    prepend-icon = "mdi-calendar"
                    v-model = "selectEndDate"
                    label = "Fecha final"
                    required
                    readonly>
                </v-text-field>
                <v-date-picker header-color = "green darken-3" dark v-model = "selectEndDate" @input="$refs.menufechafin.save(selectEndDate)"></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex>
        <v-container>
          <v-layout row wrap>
            <v-flex md4>
              <v-card>
                <v-card-title primary-title class="teal darken-4 white--text">
                  <div class="headline">Grupos abiertos</div>
                </v-card-title>
                <v-card-text>
                  <center>
                    <span class="title">{{ gAbiertos }}</span>
                    <span class="body-1 blue-grey--text">/{{ gAbiertos }}</span>
                  </center>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md4>
              <v-card>
                <v-card-title primary-title class="teal darken-4 white--text">
                  <div class="headline">Centros Comunitarios registrados</div>
                </v-card-title>
                <v-card-text>
                  <center>
                    <span class="title">{{ cRegistrados }}</span>
                  </center>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md4>
              <v-card>
                <v-card-title primary-title class="teal darken-4 white--text">
                  <div class="headline">Beneficiarios inscritos</div>
                </v-card-title>
                <v-card-text>
                  <center>
                    <span class="title">73</span><br>
                  </center>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md6>
              <v-card>
                <v-card-title primary-title class="teal darken-4 white--text">
                  <div class="headline">Cursos por centro comunitario</div>
                </v-card-title>
                <v-card-text>
                  <center>
                    <material-chart-card
                      :data="centrocomunitario.datos"
                      :options="centrocomunitario.opciones"
                      color="blue darken-3"
                      type="Line"
                    >
                    </material-chart-card>
                  </center>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md6>
              <v-card>
                <v-card-title primary-title class="teal darken-4 white--text">
                  <div class="headline">Bolsa de trabajo</div>
                </v-card-title>
                <v-card-text>
                  <center>
                    <material-chart-card
                      :data="bolsaDeTrabajo.datos"
                      :options="bolsaDeTrabajo.opciones"
                      color="blue darken-3"
                      type="Line">
                    </material-chart-card>
                  </center>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>      
</template>

<script>
  import ServiceHandler from '../ServiceHandler';
  
  export default {
    data: () => ({
      centrocomunitario: {
        datos: {
          labels: ['Enero', 'Febrero', 'Marzo'],
          series: [ [0], [0], [0] ]
        },
        opciones: {
          low: 0,
          high: 100, // Calcular automatico: valor mas alto + algo extra para mejorar visuualizacion
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },

      bolsaDeTrabajo: {
        datos: {
          labels: ['Enero', 'Febrero', 'Marzo'],
          series: [ [0], [0], [0] ]
        },
        opciones: {
          low: 0,
          high: 100, // Calcular automatico: valor mas alto + algo extra para mejorar visuualizacion
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },

      date: null,
      menufechaini: null,
      menufechafin: null,
      dateFormatted: null,
      selectCommunities: undefined,
      itemsCommunities: [],
      gAbiertos: 0,
      cRegistrados: 0,
      bRegistrados: 0,

      selectSample: undefined,
      itemsSample: [
        "En cursos",
        "Graduados",
      ],

      selectTime: undefined,
      itemsTime: [
        "3 meses",
        "6 meses",
        "12 meses",
        "18 meses",
        "24 meses",
        "36 meses",
      ],

      selectInitialDate: undefined,
      selectEndDate: undefined,
      
    }),

    computed: {
      
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      async initialize () {
        try{
          var tmp = await ServiceHandler.getElements("centros");
          this.cRegistrados = tmp.length;
          if(tmp.length > 0){
            for(var i=0; i<tmp.length; i++){
              this.itemsCommunities.push(tmp[i].nombre);
            }
          }
          var tmpG = await ServiceHandler.getElements("grupos");
          this.gAbiertos = tmpG.length;

          var tmpB = await ServiceHandler.getElements("beneficiarios");
          this.bRegistrados = tmpB.length;
        }catch(e){}
      }
    }
  }
</script>